
<div class="m-auto center">
    <div class="">
        <mat-icon>error</mat-icon>
            <h4 class="text">L'e-mail è stata già confermata</h4>
             <div class="login">
                <button type="button" class="btn button" (click)="onSubmit()">Torna alla login</button>
             </div>
     </div>
</div>